import { render, staticRenderFns } from "./SuppliersEdit.vue?vue&type=template&id=d7fffa78&lang=pug&"
import script from "./SuppliersEdit.vue?vue&type=script&lang=ts&"
export * from "./SuppliersEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports